import { request } from "services/api/util";

class CounterServiceService {
    async getCounterService(storeCode) {
        const config = {
            method: "GET",
            url: `/admin/store/${storeCode}/serviceStore`,
            headers: {
                "content-type": "application/json;charset=UTF-8",
            }
        };
        return request(config);
    }

    async upsertCounterService(storeCode, body) {
        const config = {
            method: "post",
            url:`/admin/store/${storeCode}/serviceStore`,
            data: body,
            headers: {
                "content-type": "application/json;charset=UTF-8",
            }
        };
        return request(config);
    }
}

export default new CounterServiceService();